module.exports = __webpack_public_path__ + "images/stickers/taco-clean.1dcbe23dec5243cecec8.png";